@import "../../arrow";

@mixin hover-focus-colors {
  background-color: $color-horizon !important; // !important because :first-of-type otherwise wins
}

@mixin hover-focus-colors-dark-theme {
  background-color: $color-dusk-tint-4-dark-theme !important; // !important because :first-of-type otherwise wins
}

:host {
  display: block;

  > .component {
    &.focused {
      > .arrow,
      > .body {
        @include hover-focus-colors;
        @include focus-visible;
      }
    }

    > .body {
      position: relative;
      background-color: $color-white;
      color: $token-text-color-interaction-default;
      display: flex;
      gap: $baseline;
      padding: 12px $baseline-3;
      text-decoration: none;
      transition:
        border-bottom 200ms $button-easing,
        color 200ms $button-easing;
      outline: none;
    }
  }
}

:host(.selectable) {
  > .component {
    > .body {
      cursor: pointer;
    }
  }
}

:host(:not(.selectable)) {
  > .component {
    > .body {
      cursor: not-allowed;
    }
  }
}

:host(.selectable:hover) {
  > .component {
    > .arrow,
    > .body {
      @include hover-focus-colors;
    }
  }
}

:host(.disabled) {
  > .component {
    > .body {
      @include disabled;
      color: $color-disabled;
    }
  }
}

:host(:first-of-type) {
  > .component {
    > .body {
      border-top-left-radius: $border-radius-large;
      border-top-right-radius: $border-radius-large;
      padding-top: $baseline-2;
    }
  }
}

:host(:last-of-type) {
  > .component {
    > .body {
      border-bottom-left-radius: $border-radius-large;
      border-bottom-right-radius: $border-radius-large;
      padding-bottom: $baseline-2;
    }
  }
}

:host(.bottom-right:first-of-type),
:host(.bottom-left:first-of-type) {
  > .component {
    > .arrow {
      display: block;
      top: -($arrow-width * 0.5);
      box-shadow: -1px -1px 2px 0 rgba($color-black, 0.15);
    }
  }
}

:host(.top-right:last-of-type),
:host(.top-left:last-of-type) {
  > .component {
    > .arrow {
      display: block;
      bottom: -($arrow-width * 0.5);
      box-shadow: 1px 1px 2px 0 rgba($color-black, 0.15);
    }
  }
}

:host(.sdx--dark-theme) {
  > .component {
    &.focused {
      > .arrow,
      > .body {
        @include hover-focus-colors-dark-theme;
        @include focus-visible--dark-theme;
      }
    }

    > .body {
      @include font-plain;
      background-color: $color-dusk-tint-2-dark-theme;
      color: $color-int-blue2-dark-theme;
    }
  }
}

:host(.sdx--dark-theme) {
  > .component {
    > .arrow {
      background-color: $color-dusk-tint-2-dark-theme;
    }
  }
}

:host(.sdx--dark-theme.selectable:hover) {
  > .component {
    > .arrow,
    > .body {
      @include hover-focus-colors-dark-theme;
    }
  }
}

:host(.disabled.sdx--dark-theme) {
  > .component {
    > .body {
      color: $color-disabled-dark-theme;
    }
  }
}
